import {
	TAUX_ABATTEMENT_PASS,
	TAUX_COTISATION_MALADIE,
} from '@/contextes/frontalier-suisse'

import { Décomposition } from './Décomposition'

export const tauxAbattement = Math.round(TAUX_ABATTEMENT_PASS * 100)
export const tauxCotisation = Math.round(TAUX_COTISATION_MALADIE * 100)

export const metadata = {
	title: 'Comprendre le calcul de votre cotisation maladie',
	description:
		'Le détail du calcul de la cotisation maladie des travailleur·euses frontalier·ères en Suisse',
}

En tant que **travailleur·euse frontalier·ère en Suisse**, affilié·e à l’assurance maladie française, votre cotisation est calculée chaque année par l’Urssaf à partir de vos revenus.

## La formule

> **Cotisation annuelle = (assiette − abattement) × {tauxCotisation} %**

- **Assiette retenue** : la somme de vos **salaires** et de vos **autres revenus** de l’année.
- **Abattement** : **{tauxAbattement} % du plafond annuel de la Sécurité sociale (PASS)**, revalorisé chaque année.
- **Taux** : **{tauxCotisation} %**.
- **Arrondi** : à l’euro le plus proche.

La cotisation estimée à partir de ces revenus s’appliquera deux ans plus tard.

## Les années partielles (prorata)

Si votre affiliation commence ou se termine en cours d’année, la cotisation de cette année-là est proratisée au nombre de jours d’affiliation :

> **Cotisation de l’année = cotisation annuelle × jours d’affiliation ÷ nombre de jours de l’année**

## Votre calcul

<Décomposition />
